/* eslint-disable @typescript-eslint/ban-ts-comment */
import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';
import { throwErrorWithId } from '@pypestream/utils';

import { ProStudioContext, ProStudioEvents } from '../prostudio.xstate.types';
import { checkForErrors } from '../../utils';
import { tableStore } from '../../stores/table-store';

export const deleteScript = async (
  ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<{ draft: ProStudioContext['draft'] } | void> => {
  if (event.type !== 'deleteScript') {
    return;
  }

  const { botName, customerId, draftVersion, project } = ctx;

  const projectId = project?.id;

  if (!projectId) {
    throwErrorWithId('Project ID is required');
    return;
  }

  if (!botName) {
    throwErrorWithId('Bot Name is required');
  }

  if (!customerId) {
    throwErrorWithId('Customer ID is required');
  }

  const botId = `${customerId}.${botName}`;

  if (!draftVersion) {
    throwErrorWithId('Draft version is required');
  }

  const deleteScriptResponse = await urqlGql.deleteScriptById({
    projectId,
    scriptId: event.id,
    versionId: `${botId}.${draftVersion}`,
  });

  checkForErrors(deleteScriptResponse);

  tableStore.rows.forEach((row) => {
    if (row.command === event.id.replace('.py', '')) {
      tableStore.updateRow({
        rowId: row.id,
        updates: { command: undefined },
      });
    }
  });

  await tableStore.validateAndSync();

  console.log('deleteScriptResponse', deleteScriptResponse);

  return {
    draft: deleteScriptResponse.data?.deleteVersionScriptById?.data,
  };
};
